import { mapDotClasses } from './helpers';

const Dot = ({ children, onCallback, size = 'medium', rotate = undefined }) => {
  const classNames = `integration__dot ${mapDotClasses['size'][size]} ${rotate && mapDotClasses['rotate'][rotate]}`;

  return (
    <div className={classNames} onClick={onCallback}>
      {children}
    </div>
  );
};

export default Dot;
